import { gql } from "@apollo/client";

export const GET_STATS = gql`
  query getStats($category: Int!, $city_id: Int!) {
    Web {
      stats(category: $category, city_id: $city_id) {
        name
        district_id
        values {
          time_range
          year
          order
          count
          price
        }
      }
    }
  }
`;

export const GET_PLUS_STATS = gql`
  query getPlusStats(
    $category: Int!
    $district_id: Int!
    $location: LocationInput
  ) {
    AqarPlus {
      plusStats(
        category: $category
        district_id: $district_id
        location: $location
      ) {
        name
        district_id
        values {
          time_range
          year
          order
          count
          price
        }
      }
    }
  }
`;
